export const nameLeagueMap: { [key in string]: string } = {
  ["first-league"]: "Первая лига",
  ["second-league"]: "Вторая лига А",
  ["third-league"]: "Вторая лига Б",
};

export const nameLeagueTitle: { [key in string]: string } = {
  ["first-league"]: "Сезоны первой лиги",
  ["second-league"]: "Сезоны второй лиги А",
  ["third-league"]: "Сезоны второй лиги Б",
};

export const leagueIndex: { [key in string]: string } = {
  ["first-league"]: "100",
  ["second-league"]: "200",
  ["third-league"]: "300",
};

export const translationsTypesSelect = [
  {
    key: "vk",
    value: "Вконтакте",
  },
  // {
  //   key: "youtube",
  //   value: "Youtube",
  // },
  {
    key: "match-tv",
    value: "Матч тв",
  },
  {
    key: "match-premier",
    value: "Матч премьер",
  },
  {
    key: "kinopoisk",
    value: "Кинопоиск",
  },
  {
    key: "tricolor",
    value: "Триколор",
  },
];

export const mediaTypeSelect = [
  {
    key: "PHOTO",
    value: "Альбом изображений",
  },
  {
    key: "LINK",
    value: "Ссылка",
  },
];

export const colorTypeSelect = [
  {
    key: "#000000",
    value: "Черный",
  },
  {
    key: "#808080",
    value: "Серый",
  },
  {
    key: "#C0C0C0",
    value: "Серебряный",
  },
  {
    key: "#FFFFFF",
    value: "Белый",
  },
  {
    key: "#FF00FF",
    value: "Розовый",
  },
  {
    key: "#800080",
    value: "Фиолетовый",
  },
  {
    key: "#FF0000",
    value: "Красный",
  },
  {
    key: "#800000",
    value: "Бордовый",
  },
  {
    key: "#FFFF00",
    value: "Желтый",
  },
  {
    key: "#FF4500",
    value: "Оранжевый",
  },
  {
    key: "#00FF00",
    value: "Лайм",
  },
  {
    key: "#008000",
    value: "Зеленый",
  },
  {
    key: "#00FFFF",
    value: "Голубой",
  },
  {
    key: "#0000FF",
    value: "Синий",
  },
];

export const colorNamesSelect = [
  "Бело-голубые",
  "Бело-красные",
  "Бело-синие",
  "Бордовые",
  "Голубые",
  "Желто-зеленые",
  "Желто-красные",
  "Желто-синие",
  "Желто-черные",
  "Зеленые",
  "Зелено-белые",
  "Зелено-желтый",
  "Зелено-красные",
  "Зелено-синие",
  "Красные",
  "Красно-белые",
  "Красно-желтые",
  "Красно-зеленые",
  "Красно-синие",
  "Красно-черные",
  "Небесные",
  "Небесно-бордовые",
  "Оранжевые",
  "Синие",
  "Сине-белые",
  "Сине-голубые",
  "Сине-желтые",
  "Сине-черные",
  "Темно-синие",
  "Фиолетовые",
  "Черно-белые",
  "Черно-желтые",
  "Черно-зеленые",
  "Черно-оранжевые",
  "Черно-синие",
];
